import React from 'react';
import { Container } from 'reactstrap';

export class ComponentFrame extends React.Component {

  render() {
    const {
      tag: Tag,
      color
    } = this.props;

    const header = this.props.header || null;
    const footer = this.props.footer || null;

    const Wrapper = this.props.container ? Container : "div";

    let style = {};

    if(this.props.style){
      style = { ...this.props.style };
    }

    style.backgroundColor = color;

    return (
      <Tag className={ this.props.className || '' } style={{ ...style }}>
        <Wrapper>
          { header }
          <div>
            { this.props.children }
          </div>
          { footer }
        </Wrapper>
      </Tag>
    );
  }
}

ComponentFrame.defaultProps = {
  tag: 'div',
  color: 'transparent'
};



// WEBPACK FOOTER //
// ./src/frame/ComponentFrame.js